import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";


import Breadcrumbs from "components/Common/BreadcrumbTitle";
import {getNotesTableData} from "../../http/fundLync/entityAndAddress.helper";
import { decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import { downloadSystemConfigFile } from "http/UAM/systemConfig.helper";



const TableActionsComponent = ({ rowData, onEditNote}) => {
  const navigate = useNavigate();
  const entityDetails = decryptedValue(localStorage.getItem("user"));
  
  const navigateToEditNotes = (id) => {
    const encryptedId = btoa(id.toString());
      navigate(
        `/edit-entity-notes?id=${encodeURIComponent(
          encryptedId
        )}`
      );
  };

  

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
            onClick={() => {
              onEditNote(rowData.id);
            }}
            >
            <i
                className="mdi mdi-pencil font-size-16 text-success me-1"
                id="edittooltip"
            ></i>
            Edit
            <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
            </UncontrolledTooltip>
            </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const EntityNotesTable = ({onCreateNewNote,onEditNote}) => {
  document.title = "Meeting Table | Fundlync";

  const navigate = useNavigate();
  const [notesList, setNotesList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
  const userObj = decryptedValue(localStorage.getItem("user"))|| "{}";
  const { entityType } = userObj || "";
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action",'additionalDocuments'],
  });
  const [entityId, setEntityId] = useState();
  const [toastInfo, setToastInfo] = useState({
    message: "",
    showToast: false,
    role: "",
  });
  const urlParams = new URLSearchParams(window.location.search);
  const filterType = urlParams.get("filter");
  let decodeFilterType = atob(urlParams.get("filter"));

    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const encodedId = urlParams.get("id");
      if (encodedId) {
          const decodedId = atob(encodedId);
          setEntityId(decodedId);
      } else {
        const entity = decryptedValue(localStorage.getItem("user"));
        setEntityId(entity.entityId);
      }
  }, []);

  const entityDetails = decryptedValue(localStorage.getItem("user"));

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Notes Title",
        accessor: "notes",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Uploaded Documents",
        accessor: "additionalDocuments",
        filterable: false,
        Cell: ({ value, row }) => {
          const files = value && value[0]?.file_path || [];
          return (
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {files.map((file, fileIndex) => (
                <span key={`file-${row.id}-${fileIndex}`} style={{ marginRight: '10px' }}>
                  <i
                    className="mdi mdi-download"
                    style={{
                      fontSize: "25px",
                      cursor: "pointer",
                      color: "#34c38f",
                    }}
                    onClick={() => {
                      formatFunction(
                        file,
                        handleToast
                      );
                    }}
                    id={`download-icon-${row.id}-${fileIndex}`} 
                  >
                  </i>
                  <UncontrolledTooltip
                    placement="top"
                    target={`download-icon-${row.id}-${fileIndex}`}
                  >
                    {extractFileName(file)}
                  </UncontrolledTooltip>
                </span>
              ))}
            </div>
          );
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return (
            <TableActionsComponent
              rowData={rowData}
              onEditNote={onEditNote}
            />
          );
        },
      },
    ],
    []
  );
  const handleToast = (info) => {
    setToastInfo(info);
  };
  const extractFileName = (url) => {
    const segments = url.split('/');
    return decodeURIComponent(segments[segments.length - 1]);
  };

  function formatFunction(file, showToastCallback) {
    const str = file.substring(file.indexOf("com") + 4);
    const filename = file.substring(file.lastIndexOf("/") + 1);
    const ext = str.split(".").pop();
    const obj = {
      fileName: str,
    };
  
    downloadSystemConfigFile(obj)
      .then((response) => {
        if (response.code === 200) {
          downloadFile(response.result, ext, filename);
          showToastCallback({
            message: "Downloaded successfully",
            showToast: true,
            role: "success",
          });
        } else {
          showToastCallback({
            message: response.message,
            showToast: true,
            role: "error",
          });

        }
      })
      .catch((error) => {});
  }
  function downloadFile(base64String, ext, fileName) {
    let source = "";
    if (ext == "zip") {
      source = `data:application/zip;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = fileName;
      link.click();
    } else {
      source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = fileName;
      link.click();
    }
  }
  const user = decryptedValue(localStorage.getItem("user"));

  const getNotesList = (data) => {
    const requestData = { ...data, entityId ,user};

    getNotesTableData(requestData)
      .then((responseFromAPI) => {        
        if (responseFromAPI.status && responseFromAPI.code === 200) {
          setNotesList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data;
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        } else {
          setNotesList([]);
          setPagination({
            pageIndex: 0,
            pageCount: 0,
            totalRecords: 0,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching meetings", error);
      });
};

const handlePageChange = (
  page,
  pageSize,
  searchKey=searchValue,
  columnName = columnId,
  sortingOrder = sortingOrderStatus
) => {
  setPageSize(pageSize);
  const data = {
    page,
    limit: pageSize,
    searchKey,
    columnName,
    sortingOrder,
  };
  if (filterType) {
    data.filterType = decodeFilterType;
  }
  getNotesList(data); 
};

const handleSortColumn = (option) => {
  setSortingOptions(option);
  const columnName = option.column;
  setColumnId(columnName);
  const sortingOrder = option.isAsc ? "asc" : "desc";
  setSortingOrderStatus(sortingOrder);
  handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
};

const handleSearchFilter = (value, pageSize) => {
  if (filterType) {
    if (value) {
      setSearchValue(value);
      handlePageChange(1, pageSize, value);
    } else {
      setSearchValue(decodeFilterType);
      handlePageChange(1, pageSize, decodeFilterType);
    }
  } else {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  }
};

const handleClearSearch = () => {
  if (filterType) {
    setSearchValue(decodeFilterType);
    handlePageChange(1, pageSize, decodeFilterType);
  } else {
    setSearchValue("");
    handlePageChange(1, pageSize, "");
  }
};

useEffect(() => {
  if (entityId) {
    if (filterType) {
        getNotesList({ searchKey: `${decodeFilterType}` });
    } else {
      getNotesList({});
    }
  }
}, [entityId, filterType]); 

useEffect(() => {
  checkPermissions();
}, []);

  const checkPermissions = async () => {
    const isNewEntitypermission = await isPermission(
      "apiConfiguration",
      "create_permission"
    );
    setIsNewEntityPermission(isNewEntitypermission);
  };

  const navigateToAddNotes = () => {
    const encryptedId = btoa(entityId.toString());
    navigate(`/${entityDetails.roleName}/entity/add-notes?id=${encryptedId}`);
  };
  
  const buttonSection = (
    <div className="text-sm-end">
        <Button
          type="button"
          style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }}
          className="mb-2 me-2"
          onClick={onCreateNewNote}
        >
          <i className="mdi mdi-plus me-1" />
          {"Create Note"}
        </Button>
    </div>
  );
  return (
    <React.Fragment>
      <Col xs="12">
        <TableContainerV1
            columns={columns}
            data={notesList? notesList: []}
            pagination={pagination}
            handlePageChange={handlePageChange}
            handleSearchFilter={handleSearchFilter}
            sortOptions={sortingOptions}
            customSection={buttonSection}
            handleSortColumn={handleSortColumn}
            handleClearSearch={handleClearSearch}
            className="custom-header-css"
        />
      </Col>
    </React.Fragment>
  );
};

export default EntityNotesTable;
